import React from 'react'
import styles from './styles/Sidebar.module.scss'
import { Link, useLocation } from 'react-router-dom'
import { Core } from 'core'
import classNames from 'classnames'
import { useWindowDimensions } from 'hooks'
import { useAuthStore } from 'store'
import {useCookies} from "react-cookie";

export default function Sidebar({ opened }: SidebarProps) {
  const { user } = useAuthStore()
  const { width } = useWindowDimensions()
  const [menu, setMenu] = React.useState<any[]>([])
  const { pathname } = useLocation()
  const removeCookie = useCookies(['token', 'user'])[2]

  const showInventoryShedule = ['DRESSER', 'SUDO', 'DEVELOPER'].includes(user.role)


  function logout() {
    localStorage.removeItem("access_token")
    removeCookie('user')
    window.location.href = '/';
  }

  React.useEffect(() => {
    async function checkPermissions() {
      for (let model of Object.keys(Core)) {
        if (model === 'InventoryCategory') {
          continue
        }

        const allowed = Core[model].capabilities.findAll === true

        if (allowed) {
          setMenu((prev) => (prev.indexOf(model) === -1 ? [...prev, model] : prev))
        }
      }
    }

    checkPermissions()
  }, [])

  return (
    <div className={classNames(styles.container, opened && styles.opened)}>
      {menu
        .filter((name) => Core[name].labels && Core[name].labels.menuText)
        .map((model) => (
          <Link
            key={model}
            to={Core[model].url}
            className={pathname.includes(Core[model].url) ? styles.active : undefined}
          >
            {Core[model].labels.menuText}
          </Link>
        ))}
      {showInventoryShedule && (
        <Link to="/inventory-parks" className={styles.settings}>
          Таблица инвентаря
        </Link>
      )}
      {width <= 600 && (
        <Link to="/settings" className={styles.settings}>
          Настройки
        </Link>
      )}

      {width <= 600 && (
          <Link to='/' onClick={logout} style={{ color: "red", fontWeight: "bold" }}>
            Выйти
          </Link>
      )}
    </div>
  )
}

type SidebarProps = {
  opened: boolean
}
